/**
 * Scrap
 */

import Config from '../Config';
import Util from '../Util';

class Scrap {

	private _id: string;

	private articleId: string;

	private targetUrl: string;

	private selector: string;

	constructor( parentId: string ) {
		this._id = parentId || `viewMoreList`;
		this.articleId = Util.getParams().articleId;
		this.targetUrl = location.href;
		this.addSelector();
		this.addEvent();
	}

	private addSelector() {
		this.selector = `#${this._id} .co-btn-bookmark`;
	}

	private template() {
		return `<li class="more-items"><button class="co-btn co-btn-bookmark">${Config.L10N.more_bookmark}</button></li>`;
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', this.selector, ( evt ) => {
			evt.preventDefault();
			this.scrap();
		});
	}

	private scrap() {
		const scrapPromise = Util.get( Config.scrap({
			board: Config.board,
			articleId: this.articleId}), 'POST', {
				boardAlias: Config.board,
				targetUrl: this.targetUrl,
			});
		const scrap$ = Util.from( scrapPromise );
		scrap$.subscribe( ( data: any ) => {
			if ( data !== -1 ) {
                jQuery( this.selector ).addClass( 'is-active' );

                if ( Config.isBookmarkMessage === true ) {
                    Config.confirm( Config.L10N.bookmark_have_done, () => {
                        location.href = Config.bookmarkUrl;
                    }, () => {
                        // reject
                    });
                }
			} else {
				Config.alert( Config.L10N.bookmark_already_have_done );
				Config.apiError( data );
			}

		}, ( data: any ) => {
			Config.apiError( data );
		});
	}

	private scrapList() {
		// scrapList
	}

	private isScrap() {
		// isScrap
	}
}

export default Scrap;
